var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.initialized ? _c('div', {
    staticClass: "redirect"
  }, [_c('div', {
    staticClass: "pa-5"
  }, [_c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t('redirect_choose_rule')) + " ")]), _c('div', {
    staticClass: "section"
  }, [_c('v-radio-group', {
    staticClass: "radio-ctn",
    model: {
      value: _vm.formRedirectionMode,
      callback: function callback($$v) {
        _vm.formRedirectionMode = $$v;
      },
      expression: "formRedirectionMode"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "stc",
      "label": _vm.$t('redirect_custom_landing_page')
    }
  }), _c('div', {
    staticClass: "inset font-weight-light"
  }, [_vm._v(" " + _vm._s(_vm.$t('redirect_custom_landing_page_description')) + " ")]), _c('div', {
    staticClass: "help-ctn mt-5"
  }, [_c('v-radio', {
    attrs: {
      "disabled": !_vm.isAvailable('editor:redirect:url'),
      "value": "url"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t('redirect_redirect_one_url')) + " ")])], 2), _c('info-tooltip', {
    staticClass: "redirect-tooltip",
    attrs: {
      "position": "left",
      "content": _vm.$t('redirect_info_company_url')
    }
  })], 1), _c('div', {
    staticClass: "inset"
  }, [_c('div', {
    staticClass: "font-weight-light"
  }, [_vm._v(" " + _vm._s(_vm.$t('redirect_all_qr_scans_url')) + " ")]), _c('div', {
    staticClass: "card-input-ctn"
  }, [_c('v-form', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "autocomplete": "false",
      "name": "hidden",
      "type": "text"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('redirect_enter_url'),
      "name": "url",
      "disabled": _vm.formRedirectionMode != 'url',
      "rules": this.urlRules,
      "dense": "",
      "placeholder": _vm.$t('redirect_url_placeholder')
    },
    model: {
      value: _vm.url,
      callback: function callback($$v) {
        _vm.url = $$v;
      },
      expression: "url"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "help-ctn"
  }, [_c('v-radio', {
    attrs: {
      "disabled": !_vm.isAvailable('editor:redirect:product'),
      "value": "product"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t('redirect_product_specific_url')) + " ")])], 2), _c('info-tooltip', {
    staticClass: "redirect-product-tooltip",
    attrs: {
      "position": "left",
      "content": _vm.$t('redirect_info_product_url')
    }
  })], 1), _c('i18n', {
    staticClass: "inset font-weight-light",
    attrs: {
      "path": "redirect_product_qr_description",
      "for": "product_url"
    },
    scopedSlots: _vm._u([{
      key: "product_url",
      fn: function fn() {
        return [_c('a', {
          staticClass: "font-weight-bold",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              return _vm.redirectToProducts($event);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('product_url')))])];
      },
      proxy: true
    }], null, false, 1718916357)
  })], 1)], 1)])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }